import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

export const deleteUserAccount = async () => {
  const response = await axiosInstance.delete(API_ROUTES.UserWithdraw)
  return response.data
}
